import httpUtils from '../../utils/HttpUtils'

class AnswerService {

  //获取回答列表信息
  async list(questionId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/qa/answer/list',{questionId})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  //获取回答详情信息
  async detail(id = '') {
    let result = null;
    try {
      result = await httpUtils.post('/qa/answer/detail',{id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存问题信息
  async save(answer) {
    let result = null;
    try {
      result = await httpUtils.post('/qa/answer/save',answer)
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

}
export default new AnswerService()
